import React from "react";

import "./index.sass";

import {VillageLink} from "../../../react/components/travian/ingameLinks.jsx";
import {xy2id} from "../../../travian/coordinates.js";
import {Button, ButtonTypes} from "../../../react/components/ui/spectre/buttons.jsx";
import {FormatDateTimeShorter} from "../../../helper/dateTime.js";
import {UnitRowCompact} from "../../../react/components/travian/units.jsx";
import {ResourcesIcon} from "../../../react/components/ui/tIcon.jsx";
import {FormatDecimalNumber} from "../../../helper/numbers.js";
import {getTranslator} from "../../../translate.js";
import {URL} from "../../../react/components/ui/link.jsx";

const translate = getTranslator('tool/trav/24');

/**
 * @param oasisData {{ x, y, time, linkToAttack, needsScan, heroBounty, bounty, lastAttack, bonusType, id, selected, distance, hasPositiveOutcome, bestProfitPUT, duration, lastAttackSent, lastAttackVillage }}
 * @param onCheckboxChange
 * @param ownX {int}
 * @param ownY {int}
 * @param ownTroops {int}
 * @returns {JSX.Element}
 * @constructor
 */
export function FreeOasis({oasisData, onCheckboxChange, ownX, ownY, ownTroops}) {
    const oasisUnitArray = Array(10)
        .fill(0)
        .map((_, i) => oasisData['t' + (i + 1)]);
    const hasAnyAttack = (oasisData.lastAttackSent ?? oasisData.lastAttack ?? 0) > 0;
    const showLastAttack = hasAnyAttack ? Math.max(oasisData.lastAttackSent ?? 0, oasisData.lastAttack ?? 0) : 0;
    return <div className='freeOasisRow'>
        <div><input checked={oasisData.selected} type='checkbox'
                    onChange={e => onCheckboxChange(oasisData.id, e.target.checked)}/></div>
        <div onClick={() => onCheckboxChange(oasisData.id, !oasisData.selected)}
             className='freeOasisClickableContainer'>
            <div className='text-left'>(</div>
            <div className='freeOasisCoordinate'>{oasisData.x}</div>
            <div className='text-center'>|</div>
            <div className='freeOasisCoordinate'>{oasisData.y}</div>
            <div className='text-right'>)</div>
        </div>
        <div className='pl-2 pr-2 text-center'>
            <URL href={oasisData.linkToAttack} target="_blank">
                <Button buttonTypes={[ButtonTypes.small, ButtonTypes.primary]}>A</Button>
            </URL>
            <VillageLink
                vid={xy2id({x: oasisData.x, y: oasisData.y})}
                autoName={false}
            >
                <Button buttonTypes={[ButtonTypes.small, ButtonTypes.primary]}>O</Button>
            </VillageLink>
        </div>
        <div className={oasisData.needsScan ? 'scanTooOld' : ''}>{FormatDateTimeShorter(oasisData.time)}</div>
        <div>
            <UnitRowCompact
                tribe={4}
                units={oasisUnitArray}/>
        </div>
        <div className={(oasisData.lastAttackSent ?? 0) > oasisData.lastAttack ? 'currentlyAttacking' : ''}>
            {showLastAttack === 0 ? translate('attack_never') : FormatDateTimeShorter(showLastAttack)}
        </div>
        <div>
            <ResourcesIcon/> {FormatDecimalNumber(oasisData.bounty.reduce((a, b) => a + b, 0))}
        </div>
        <div>
            <ResourcesIcon/> {FormatDecimalNumber(oasisData.heroBounty.reduce((a, b) => a + b, 0))}
        </div>
        <div>{FormatDecimalNumber(Math.round(oasisData?.bestProfitPUT?.score ?? 0))}</div>
        <div>{!oasisData.hasPositiveOutcome ? null : <>{oasisData.bestProfitPUT.units} - {oasisData.bestProfitPUT.actualLosses}</>}</div>
        <div>
            {
                !oasisData.hasPositiveOutcome ? null : <>
                    {Math.round(oasisData.bestProfitPUT.lossRatio * 100)}% /
                    {Math.round(oasisData.bestProfitPUT.desiredLossRatio * 100)}%
                </>
            }
        </div>
    </div>
}
